var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-search u-row" },
    [
      _c("icon-search", { staticClass: "cl-blue" }),
      _vm._v(" "),
      _c("input", {
        ref: "input",
        attrs: {
          type: "text",
          placeholder: "渋谷区 , 神泉駅",
          disabled: _vm.disabled
        },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event.target.value)
          },
          compositionstart: function($event) {
            _vm.composing = true
          },
          compositionend: function($event) {
            _vm.composing = false
          },
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.enter($event)
          }
        }
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }